import { IBizDays, ICalendar } from '@/appLogic/interfaces/date';
import { getCalendar } from '../checkCalendar';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { confirmPossibleSimulate } from '../business/inventorySimulation';
import { simpleCopy } from '@/utils/deepCopy';
import { putPreference } from '../preferenceManage';
import { getOrganizationId } from '../initializers/organizationId';
import { SimulationPeriodType } from '../interfaces/simulation';

/**
 * csv読み取り
 * @param csv
 */
const calenderConvert = (csv?: any): IBizDays[] => {
  const lists: IBizDays[] = [];
  const lines: string[] = csv.split('\n');

  const firstLine: string = lines.shift() as string; // TODO: 正しいフォーマットのデータが入力されることを前提にしているので本当はエラーハンドリングが必要
  let year = Number(firstLine.split(',')[0].replace('年度', ''));

  lines.forEach((daysInMonth) => {
    const monthDays = daysInMonth.split(',');
    if (monthDays.length < 3) return;
    const monthStr = monthDays.shift() as string; // TODO: 正しいフォーマットのデータが入力されることを前提にしているので本当はエラーハンドリングが必要
    const month = Number(monthStr.replace('月', ''));
    if (month === 1) year++; // 年度のカレンダーであることが前提になっているので、1月から始まるカレンダーが入力されたらうまく動かない
    lists.push({
      year,
      month,
      days: monthDays.map(Number).filter((val) => val > 0),
    });
  });
  return lists;
};

/**
 *
 * @param year
 * @param month
 * @param calendar
 */
const workingDayCalendarLength = async (year: number, month: number, calendar: ICalendar): Promise<number> => {
  // year,monthを指定してその日付の稼働日となっている日付の長さを取得
  const workDays: IBizDays[] = calendar.workDays;
  let target: IBizDays | undefined = undefined;
  for (let i = 0; i < workDays.length; i++) {
    // O(n)
    if (workDays[i].year == year && workDays[i].month == month) {
      target = workDays[i];
    }
  }
  if (target) {
    return target.days.length;
  }
  return -1;
};

/**
 * モーダル出す？出さない？
 * @param calendar
 * @param startDate
 * @param period
 */
const shouldShowWorkDaysCalendarNotEnteredAlertModal = async (
  calendar?: ICalendar,
  startDate?: Date,
  period?: SimulationPeriodType | number // 終端位置の計算はここでは行わない
): Promise<boolean> => {
  // カレンダー情報の取得
  if (!calendar) {
    calendar = simpleCopy(await getCalendar());
  }
  // シミュレーションの開始位置の設定
  if (!startDate) {
    startDate = startDate ? new Date(startDate) : new Date();
  }
  if (!calendar.unRegisterCalendarAlert) {
    calendar.unRegisterCalendarAlert = {
      updateAt: Math.floor(new Date().getTime() / 1000),
      isDisplay: true,
    };
  }
  // カレンダーアラート表示フラグの登録日時を確認する
  const registeredDate: Date = new Date(calendar.unRegisterCalendarAlert.updateAt * 1000);
  // 本日の日付情報を取得
  const nowDate: Date = new Date();
  // 日付更新の差分を見たいので、時間を0時にする
  registeredDate.setHours(0, 0, 0, 0);
  nowDate.setHours(0, 0, 0, 0);
  const diffDays: number = DateService.calculateDiffDays(nowDate, registeredDate);
  // 表示フラグとの差分が1日以上だったら表示側に倒す
  if (diffDays > 0 && calendar.unRegisterCalendarAlert.isDisplay === false) {
    calendar.unRegisterCalendarAlert.isDisplay = true;
  }
  // // カレンダーアラート表示フラグがfalseだった場合
  if (!calendar.unRegisterCalendarAlert.isDisplay) return false;
  // 登録されている稼働日のチェックを行う
  const checkResult = await confirmPossibleSimulate(calendar, startDate, period);
  if (!checkResult) {
    // 正確な稼働日情報が登録されていない場合、警告モーダルを出す
    return true;
  } else {
    // 正確な稼働日情報が登録されている場合、カレンダー情報を更新して警告モーダルを出さない
    calendar.unRegisterCalendarAlert.updateAt = Math.floor(nowDate.getTime() / 1000);
    calendar.updatedAt = Math.floor(nowDate.getTime() / 1000);
    calendar.workDays.sort(DateService.compareYearMonths);
    await putPreference(await getOrganizationId(), 'calendar', calendar).catch((err) => console.log('err', err));
    return false;
  }
};

export { workingDayCalendarLength, calenderConvert, shouldShowWorkDaysCalendarNotEnteredAlertModal };
